import { useEffect, useState } from "react";
import Screen from "../Layouts/Screen/Screen";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import Spinner from "../../global-components/src/components/spinner/spiner";
import { useAuth, useMessage, useTheme } from "../../global-components/src";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { CreditCard, CheckCircle, Lock, CirclePlus, UserMinus } from "lucide-react";
import "./style.css";
import { errorMessage } from "../../utils/TextManagerTwo";
import { getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import { useNavigate } from "react-router-dom";
import FramesOptions from "../../components/Modals/frames-options/frames-options";
import { FrameCategory, Frame } from "../../types";
import FrameOptionsBottom from "../../components/Modals/frames-options/frames-options-bottom";
import { Icon } from "../../global-components/src/components/icon";
import PermissionCheck from "../../components/PermissionCheck";
import { t } from "../../global-components/src/i18nTranslate";

const ProfileFrames = () => {
    const { token, user, isSuper } = useAuth();
    const { setMessage } = useMessage();
    const [open, setOpen] = useState(false);
    const [myFrames, setMyFrames] = useState<Frame[]>([]);
    const [categories, setCategories] = useState<FrameCategory[]>([]);
    const [loading, setLoading] = useState(true);
    const [activating, setActivating] = useState<number | null>(null);
    const navigate = useNavigate();
    const { isDarkMode } = useTheme();
    const [openFrameId, setOpenFrameId] = useState<number | null>(null);

    useEffect(() => {
        loadFrames();
    }, []);

    const loadFrames = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${PACOCA_API_URL}/frames`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMyFrames(res.data.frames);

            const response = await axios.get(`${PACOCA_API_URL}/frames/categories`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            setCategories(response.data.categories);
        } catch(err) {
            const messageError = errorMessage(err);
            console.error(err);
            console.error(messageError);
            setMessage(messageError, "error");
        } finally {
            setLoading(false);
        }
    }

    return (
        <Screen title="Molduras" paddingTopTitle contentMenu={
            <>
                {user?.permissions?.includes("create_frame") || isSuper() ? (
                    <span className="cursor-pointer" onClick={() => navigate("/molduras/criar")} style={{  marginTop: 2 }}>
                        <Icon size={24} style={{ margin: 0, cursor: "pointer" }} invertColor={!isDarkMode} name="add_circle">
                            <CirclePlus opacity={.6} size={23}/>
                        </Icon>
                    </span>
                ): null}
            </>
        }>
            <Helmet>
                <title>Paçoca - Molduras</title>
            </Helmet>

            <div className="padding-big-screen">
                {!loading && !categories.length && (
                    <div className="user-select-none row row-empty-comment">
                        <span className="span-empty">
                            <UserMinus className="icon-empty" />
                            <h3 className="w-100 text-center">Nenhuma moldura encontrada</h3>
                        </span>
                    </div>
                ) }

                {loading ? (
                    <>
                    <div className="frames-grid">
                            {[...Array(10)].map((_, index) => (
                                <div className="d-flex justify-content-center">
                                    <div className="user-select-none frame-card">
                                        <div className={`frame-preview`}>
                                            <img  className="cursor-pointer placeholder" />
                                        </div>

                                        <h6 style={{ height: 10, width: 100 }}className="mt-2 placeholder"></h6>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <div className="">
                        {/* MINHAS MOLDURAS */}
                        {myFrames.length > 0 && (
                            <>
                                <h5 className="frames-title">Minhas molduras</h5>
                                    <div className="frames-grid">
                                        {myFrames.map(frame => (
                                            <>
                                                <div
                                                    key={frame.id}
                                                    className={`user-select-none frame-card cursor-pointer${frame.is_active_for_user ? " frame-active-card" : ""}`}
                                                    {...(window.innerWidth > 850 ? { "data-bs-toggle": "modal", "data-bs-target": `#modal-frame-${frame.id}` } : {})}
                                                    onClick={() => {
                                                        if (window.innerWidth <= 850) {
                                                            setOpenFrameId(frame.id);
                                                        }
                                                    }}
                                                >
                                                    <div className={`frame-preview ${frame.is_active_for_user ? "active" : ""}`}>
                                                        <img
                                                            src={getImagePathBucketPacoca(frame.image_path)}
                                                            alt={frame.name}
                                                            style={{ border: frame.is_active_for_user ? "1px solid var(--primary-blue)" : "" }}
                                                        />
                                                    </div>

                                                    <h6 className="mt-2">{frame.name}</h6>
                                                </div>
                                                <FramesOptions frame={frame} />
                                                <FrameOptionsBottom open={openFrameId === frame.id} setOpen={(open) => setOpenFrameId(open ? frame.id : null)} frame={frame} />
                                        </>
                                    ))}
                                </div>
                            </>
                        )}

                        {categories.map(category => (
                            <>
                                {!!category.frames.length && (
                                    <div key={category.id} className="category-block">
                                        <h5 className="frames-title mt-4"> {t(`frames.categories.${category.name}`)}</h5>

                                        <div className="frames-grid">
                                            {category.frames.map(frame => (  // mostrar apenas 4 por categoria
                                                <div
                                                    key={frame.id}
                                                    className={`user-select-none frame-card cursor-pointer${frame.is_active_for_user ? " frame-active-card" : ""}`}
                                                    {...(window.innerWidth > 850 ? { "data-bs-toggle": "modal", "data-bs-target": `#modal-frame-${frame.id}` } : {})}
                                                    onClick={() => {
                                                        if (window.innerWidth <= 850) {
                                                            setOpenFrameId(frame.id);
                                                        }
                                                    }}
                                                >
                                                    <div className={`frame-preview ${frame.is_active_for_user ? "active" : ""}`}>
                                                        <img
                                                            src={getImagePathBucketPacoca(frame.image_path)}
                                                            alt={frame.name}
                                                            style={{ border: frame.is_active_for_user ? "1px solid var(--primary-blue)" : "" }}
                                                        />
                                                    </div>
                                                    <h6 className="mt-2">{frame.name}</h6>
                                                    <span className="frame-price-tag">{frame.price ?? "Grátis"}</span>
                                                    <FramesOptions frame={frame} />
                                                    <FrameOptionsBottom open={openFrameId === frame.id} setOpen={(open) => setOpenFrameId(open ? frame.id : null)} frame={frame}/>
                                                </div>
                                            ))}
                                        </div>


                                        {/* {category.frames.length > 4 && (
                                            <div className="text-right mt-2">
                                                <button
                                                    className="btn btn-link"
                                                    onClick={() => navigate(`/molduras/categoria/${category.id}`)}
                                                >
                                                    Ver mais
                                                </button>
                                            </div>
                                        )} */}
                                    </div>
                                )}
                            </>
                        ))}
                    </div>
                )}

            </div>
        </Screen>
    );
};

export default ProfileFrames;
